export type Page<TItem> = { items: TItem[]; hasNext: boolean };

export type PageResult<TItem, TError> = { data: Page<TItem> } | { error: TError };

export type AllPagesResult<TItem, TError> = { data: TItem[] } | { error: TError };

/**
 * The items of `page`, then those of every page after it, one request at a time.
 * One failed page fails the whole list: a partial list would look complete.
 */
export const fetchAllPages = async <TItem, TError>(
    fetchPage: (page: number) => Promise<PageResult<TItem, TError>>,
    page = 1
): Promise<AllPagesResult<TItem, TError>> => {
    const result = await fetchPage(page);
    if ('error' in result) {
        return result;
    }

    const { items, hasNext } = result.data;
    if (!hasNext) {
        return { data: items };
    }

    const rest = await fetchAllPages(fetchPage, page + 1);
    return 'error' in rest ? rest : { data: [...items, ...rest.data] };
};
